/**
 * 環境依存文字使用時の動作についての解説
 */
import Win10Jis2004 from "./img/win10_jsi2004.png";
import EnvironmentSpecificCharsets from "./img/environment_specific_charsets.png";

/**
 *
 * @returns {JSX.Element} 環境依存文字使用時の動作についての解説の JSX element
 */
export const AnasysJis2004 = () => {
  return (
    <section className="c-section">
      <h2 className="p-heading-2">環境依存文字使用時の動作について</h2>

      <p className="c-text">
        お使いのOSがWindows
        11,10において環境依存文字をアナシスソフトウェア上で使用した場合、以下の動作不具合が発生いたします
      </p>

      <p className="c-text">発生する不具合</p>

      <ul className="c-square">
        <li>
          ファイル保存時(.lgg,.lgd,.bmp,.csv)にファイル名に環境依存文字を使用した場合，ファイル保存操作ができない。
        </li>
        <li>
          GHS-8AT,GHS-8AT-EXからロギングデータ読出し後のロギングデータ(.lgd)保存時に環境依存文字を使用した場合，アプリケーションが応答なし状態となる。この場合にはタスクマネージャーを起動後(Ctrl+Alt+Delete)，アナシスを強制終了します。
        </li>
        <li>
          ファイル名に環境依存文字を使用したファイル(.lgg,.lgd,gtl)を読み出すとファイルの読み込みができない。
        </li>
        <li>
          識別名，グラフタイトル，コメントに環境依存文字を使用すると ?
          マークが表示される。
        </li>
      </ul>

      <p className="c-text">
        環境依存文字を使用してファイルの読出し，書き込み動作をした場合に表示されるエラー内容（下図）,
        実際の環境依存した文字を含んだファイル名のフルパス（下図赤字）が表示されます。
        OKボタンをクリックします。
      </p>

      <img
        src={Win10Jis2004}
        alt="ファイル名に環境依存文字を使用した場合のエラーメッセージ"
      />

      <h2 className="p-heading-2">対応方法</h2>
      <p className="c-text">
        漢字変換時に環境依存文字を使わないことで前述の問題は発生しません。前述の不具合が発生した場合には操作をもう一度やり直し環境依存文字を使用しないで操作を行ってください。
      </p>

      <p className="c-text">
        環境依存文字とは Windows
        Vista以降ではJIS2004の漢字コードが追加されています。WindowsXP以前はJIS90という漢字コードを利用していてJIS90になくJIS2004だけに存在する漢字を使用する場合前述の不具合が発生します。
        例として俱 剝 噓 姸 屛 幷 瘦 繫 といった漢字が環境依存文字となります。
        Microsoft IME では、JIS2004 で追加された文字に変換しようとすると、下図
        のように、「環境依存文字
        (unicode)」というコメントが表示されるため、一目で確認することができます。
      </p>

      <img src={EnvironmentSpecificCharsets} alt="環境依存文字の確認" />
    </section>
  );
};
